import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';

import { App } from './app';
import './index.css';

import '@fontsource/inter';

const root = document.getElementById('root');
if (root == null) {
  throw new Error('Cannot render React app when root element is missing!');
}

createRoot(root).render(
  <StrictMode>
    <App />
    <ToastContainer position="top-right" autoClose={10000} pauseOnHover theme="light" />
  </StrictMode>,
);
